import React from 'react';
import { Card, CardContent, CardTitle, withGrid, Input } from '../../../Components';
import { MembroModel } from '../../../Store';
import styled from 'styled-components';
import { media } from '../../../Themes';

interface IProfCardProps extends React.InputHTMLAttributes<any> {
  membros: MembroModel[];
}

const Grid = withGrid(CardContent);
export const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const MembrosCard: React.FC<IProfCardProps> = ({ membros }: IProfCardProps) => {
  return (
    <>
      {membros.map((membro, idx) =>
        <Card key={idx}>
          <CardTitle>Membro da Banca</CardTitle>
          <CardContentGrid>
            <InputGrid
              gridColumn='1/10'
              label='Nome'
              value={membro.nome}
              disabled={true}
            />
            <InputGrid
              gridColumn='10/13'
              label='CPF'
              value={membro.cpf}
              disabled={true}
            />
            <InputGrid
              gridColumn='1/5'
              label='Email'
              value={membro.email}
              disabled={true}
            />
            <InputGrid
              gridColumn='5/9'
              label='Telefone'
              value={membro.telefone ? membro.telefone : ''}
              disabled={true}
            />
          </CardContentGrid>
        </Card>)}
    </>
  );
};

export default MembrosCard;
